module.exports = __webpack_public_path__ + "images/icon-512.bdc4d968fab85e51535269a320b5e1df.png";